(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/react/test-panel.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/react/test-panel.js');

'use strict';

var _svs$player_login$dat;
const {
  ReactButton: Button,
  ReactIcon: Icon
} = svs.ui;
const {
  Card,
  CardBody
} = svs.ui.ReactCard;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const isTestEnvironment = ((_svs$player_login$dat = svs.player_login.data.login) === null || _svs$player_login$dat === void 0 ? void 0 : _svs$player_login$dat.isTestEnvironment) || false;
const {
  LoginMethods
} = svs.accountservices.authenticate.definitions;
const SSNInput = svs.ui.reactFormInputs.SSNInput;
const {
  Form
} = svs.ui.reactForm;
const {
  useState
} = React;

const TestPanel = () => {
  var _svs$utils$url$queryS;
  const returnUrl = (_svs$utils$url$queryS = svs.utils.url.queryString) === null || _svs$utils$url$queryS === void 0 ? void 0 : _svs$utils$url$queryS.returnUrl;
  const [autoStartToken, setautoStartToken] = useState(false);
  const [inputSsn, setInputSsn] = useState('');
  const hideTestPanel = () => {
    var _document$querySelect, _document$querySelect2;
    (_document$querySelect = document.querySelector('.js-test-panel-app')) === null || _document$querySelect === void 0 || (_document$querySelect2 = _document$querySelect.remove) === null || _document$querySelect2 === void 0 || _document$querySelect2.call(_document$querySelect);
  };
  svs.accountservices.authenticate.login.on('LOGIN', hideTestPanel);
  svs.accountservices.authenticate.login.on('READY_TO_POLL', data => {
    data.autoStartToken && setautoStartToken(data.autoStartToken);
  });
  const bankdIdSimLogin = (ast, ssn) => {
    try {
      svs.accountservices.authenticate.login.off('READY_TO_POLL', onReadyToPoll);
      (() => {
        new Image().src = "https://bankid-sim.internt.svenskaspel.se/test/requests/update?autostartToken=".concat(ast, "&personalNumber=").concat(ssn, "&action=accept");
      })();
    } catch (e) {
      svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
        actions: [{
          title: 'Okej'
        }],
        area: svs.ui.dialog.area.POPUP,
        branding: 'sport',
        message: [{
          text: 'Det går inte att logga in via testpanelen just nu.'
        }],
        title: 'Något gick visst fel',
        type: svs.ui.dialog.type.ERROR
      }));
    }
  };
  const onReadyToPoll = data => {
    svs.accountservices.authenticate.login.poll();
    svs.player_login.router.navigate("bankid/poll?".concat(svs.player_login.radio.request('loginModel').toQueryString()), true);
    bankdIdSimLogin(data === null || data === void 0 ? void 0 : data.autoStartToken, inputSsn.replace(/-/g, ''));
  };
  const onSubmitHandler = async (e, formData, isValid) => {
    e.preventDefault();
    svs.player_login.utils.dontTryNavigationAppUrl = true;
    if (isValid) {
      const model = svs.player_login.radio.request('loginModel');
      if (svs.accountservices.authenticate.login.isStarted()) {
        bankdIdSimLogin(autoStartToken, inputSsn.replace(/-/g, ''));
      } else {
        svs.accountservices.authenticate.login.on('READY_TO_POLL', onReadyToPoll);
        svs.accountservices.authenticate.login.start({
          codeChallenge: model.get('codeChallenge'),
          codeChallengeMethod: model.get('codeChallengeMethod'),
          isCustomerRegistration: model.get('isCustomerRegistration'),
          isPoker: model.get('isPoker'),
          method: LoginMethods.BANKID,
          qr: true
        });
      }
    }
  };

  const acceptBankIdSimLogin = async e => {
    const {
      dialog
    } = svs.ui;
    const ast = e.currentTarget.dataset.autostarttoken;
    const retUrl = e.currentTarget.dataset.returnurl;
    const users = svs.components.Storage.browser.get('savedusers', 'svs.testlogin') || [];
    const dialogMessage = [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Välj EN kund från Snabbinloggningen.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      text: 'Det ÖVERSTA personnumret som väljs kommer att användas.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      text: "Till <a href=\"/snabb-inloggning?returnUrl=".concat(retUrl, "\">Snabbinloggningen</a> f\xF6r att hantera testkunder och/eller logga in den v\xE4gen.")
    }];
    let ssn = e.currentTarget.dataset.ssn;
    if (!ssn) {
      users.forEach(user => {
        dialogMessage.push({
          type: svs.ui.dialog.message.CHECKBOX,
          block: true,
          align: svs.ui.dialog.message.align.LEFT,
          text: "".concat(user.ssn, " ").concat(user.firstName, " ").concat(user.lastName),
          value: user.ssn
        });
      });
      const showSelectUserDialog = () => new Promise(resolve => {
        const ssnDialog = new dialog.Confirm({
          title: 'Välj kund',
          branding: svs.ui.dialog.branding.SPORT,
          icon: 'login',
          area: svs.ui.dialog.area.POPUP,
          message: dialogMessage,
          actions: [{
            title: 'Avbryt',
            callback() {
              ssnDialog.close();
              resolve();
            }
          }, {
            title: 'Logga in',
            showLoader: true,
            callback(e, forms) {
              const arrayForms = Array.from(forms);
              const selectedUser = arrayForms.find(element => element.checked);
              if (selectedUser) {
                ssn = selectedUser.value;
              }
              ssnDialog.close();
              resolve();
            }
          }]
        });
        svs.ui.dialog.api.add(ssnDialog);
      });
      await showSelectUserDialog();
    }
    if (ssn) {
      bankdIdSimLogin(ast, ssn);
    } else {
      const missingSsnDialog = new svs.ui.dialog.Confirm({
        icon: 'info',
        branding: svs.ui.dialog.branding.SPORT,
        title: 'Du måste välja en testkund.',
        actions: [{
          title: 'Okej'
        }]
      });
      svs.ui.dialog.api.add(missingSsnDialog);
    }
  };

  const navigateToQuickLogin = () => {
    svs.utils.url.navigate('/snabb-inloggning');
  };

  const showTestPanelInfo = e => {
    const {
      dialog
    } = svs.ui;
    const panelInfoDialog = new dialog.Contextual({
      area: svs.ui.dialog.area.CONTEXTUAL,
      branding: svs.ui.dialog.branding.TUR,
      attachTo: e.currentTarget,
      title: '',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: 'Med testpanelen kan du:'
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: '- Logga in via Snabbinloggningen genom att använda knappen "LOGGA IN VIA SNABBINLOGGNING". ' + 'Den tar dig till Snabbinloggningen med aktuell destination som returnUrl. Du behöver inte påbörja inloggningen.'
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: '- Acceptera inloggningen via BankID-simulatorn direkt här från logga in-sidan genom att använda knappen "ACCEPTERA MED BANKID-SIM", ' + 'som blir synlig när du har påbörjat en inloggning.'
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: '- Ange personnummer och acceptera inloggningen via BankID-simulatorn direkt här från logga in-sidan genom att ange personnummer och använda knappen "ACCEPTERA MED BANKID-SIM", ' + 'detta fungerar inte om du har påbörjat en autentisering.'
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: 'Även autoStartToken blir synlig när du påbörjar en inloggning ifall om du vill använda BankID-simulatorn för att hantera inloggningen.'
      }]
    });
    svs.ui.dialog.api.add(panelInfoDialog);
  };
  return !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && isTestEnvironment && React.createElement("div", {
    className: "login-test-panel margin-bottom-2 col-xs-12"
  }, React.createElement(Card, {
    branding: "sport"
  }, React.createElement(CardBody, {
    className: "f-body fc-navy"
  }, React.createElement("div", {
    className: "f-550 margin-xs-h-0 inline-block"
  }, "Test-panel", ' ', React.createElement("span", {
    className: "show-test-panel-info",
    onClick: showTestPanelInfo
  }, React.createElement(Icon, {
    icon: "information",
    size: "200"
  }))), React.createElement("div", {
    className: "test-panel-hide f-200 f-medium margin-xs-h-0 inline-block right",
    onClick: hideTestPanel
  }, "[D\xF6lj]"), React.createElement("div", {
    className: "margin-xs-top margin-xs-bottom-2 quick-login-button"
  }, React.createElement(Form, {
    isVertical: true,
    onSubmit: onSubmitHandler
  }, React.createElement(SSNInput, {
    name: "test-panel-ssn",
    onChange: e => setInputSsn(e.target.value),
    value: inputSsn
  }), React.createElement(Button, {
    block: true,
    className: "margin-xs-top-1",
    focus: true,
    size: 300,
    type: "submit"
  }, "Acceptera med BankID-sim"))), autoStartToken && React.createElement("div", {
    className: "margin-xs-top autostarttoken-info f-400"
  }, "AUTOSTARTTOKEN:", React.createElement("p", {
    className: "autostarttoken-info-text"
  }, autoStartToken), React.createElement(Button, {
    block: true,
    className: "margin-xs-top",
    "data-autostarttoken": autoStartToken,
    "data-returnurl": returnUrl,
    inverted: false,
    onClick: acceptBankIdSimLogin,
    size: 100,
    transparent: true
  }, "V\xE4lj anv\xE4ndare och acceptera med BankID-sim")), React.createElement("div", {
    className: "margin-xs-top quick-login-button"
  }, React.createElement(Button, {
    block: true,
    inverted: false,
    onClick: navigateToQuickLogin,
    size: 100,
    transparent: true
  }, "Till snabbinloggning")))));
};
if (isTestEnvironment) {
  ReactDOM.render(React.createElement(ErrorBoundary, null, React.createElement(TestPanel, null)), document.querySelector('.js-test-panel-app'));
}

 })(window);